// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-794dc749] {\n  width: 287px !important;\n}", ""]);
// Exports
module.exports = exports;
